import React from 'react';
import { inject, observer } from 'mobx-react';
import { Button } from 'reactstrap';
import { Heading1, Heading3, TextDefault } from '@awarego-ui/components';
import { useStores } from '../../hooks/use-stores';
import moment from 'moment';

function PaymentConfirm({ onComplete }) {
    const { subscriptionStore } = useStores();
    const { price, billingInfo, postPurchaseEstimate } = subscriptionStore;

    // Get next billing from next_invoice_estimate
    const nextBillingAmount =
        postPurchaseEstimate?.estimate?.next_invoice_estimate?.amount_due ?? 0;

    // Get next billing date
    const nextBillingDate =
        postPurchaseEstimate?.estimate?.subscription_estimate?.next_billing_at;

    const formatDate = (timestamp) => {
        if (!timestamp) return null;
        return moment.unix(timestamp).format('MM/DD/YYYY');
    };

    return (
        <div className={'wizard-fullscreen'}>
            <div className={'wizard-fullscreen-header'}>
                <Heading1>Payment successful</Heading1>
            </div>
            <div className="wizard-fullscreen-body align-items-center justify-content-center flex-column">
                <img src="/static/img/receipt.svg" alt="Email sent" />
                <Heading3 displayBlock mt={16} mb={8}>
                    Thank you!
                </Heading3>
                <div style={{ textAlign: 'center', maxWidth: '500px' }}>
                    {Number(price) > 0 ? (
                        <p>
                            Your account was charged{' '}
                            <strong className="green">
                                ${price}
                            </strong>
                            . A confirmation and receipt was also sent to{' '}
                            <strong className="green">
                                {billingInfo?.email}
                            </strong>
                            .
                        </p>
                    ) : (
                        <p>
                            Your subscription has been updated. A confirmation
                            was sent to{' '}
                            <strong className="green">
                                {billingInfo?.email}
                            </strong>
                            .
                        </p>
                    )}
                    {nextBillingDate && nextBillingAmount > 0 && (
                        <div style={{ marginTop: '16px' }}>
                            <TextDefault style={{ fontSize: '14px', display: 'block' }}>
                                Next billing on <strong>{formatDate(nextBillingDate)}</strong>
                            </TextDefault>

                            <TextDefault style={{ fontSize: '14px', display: 'block' }}>
                                Estimated bill amount:{' '}
                                <strong className="green">
                                    ${(nextBillingAmount / 100).toFixed(0)}
                                </strong>
                            </TextDefault>

                            <TextDefault
                                style={{
                                    display: 'block',
                                    marginTop: '8px',
                                    fontSize: '12px',
                                    color: '#666',
                                    fontStyle: 'italic',
                                }}
                            >
                                This estimate is based on your current subscription and usage. The final
                                amount may change if your plan, users, or credits change before the next
                                billing date.
                            </TextDefault>
                        </div>
                    )}
                </div>
            </div>

            <div className={'wizard-fullscreen-footer'}>
                <div
                    className={'actions center d-flex justify-content-end'}
                >
                    <Button color={'primary'} onClick={onComplete}>
                        OK
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default observer(PaymentConfirm);
